import MoreTool from '../tools/moreTool/MoreTool';

// Types
import { MoreToolsSettings, ToolbarItemConfig } from '../toolbarTypes';

import { COLLAPSE_ORDER } from './toolbarToolConfigConstants';
import ToolSeparator from '../../toolbar/commonComponents/ToolSeparator';

const META_MORE: ToolbarItemConfig = {
    id: 'META_MORE',
    name: 'More',
    height: {
        large: 16,
        medium: 16,
        small: 14,
    },
    collapseOrder: COLLAPSE_ORDER.NEVER,
    component: MoreTool,
    toolSettings: {
        groupSize: 3,
        items: [],
        popupId: '',
    } as MoreToolsSettings,
};

const META_DIVIDER: ToolbarItemConfig = {
    id: 'META_DIVIDER',
    name: 'Divider',
    height: {
        large: 1,
        medium: 1,
        small: 1,
    },
    collapseOrder: COLLAPSE_ORDER.NEVER,
    collapseBehavior: 'hide',
    component: ToolSeparator,
};

export default {
    META_MORE,
    META_DIVIDER,
};
